export function loginPopup() {
    const $html = this.$html;
    const $toggler = $(".login-button-wrap");
    const $popupCloseButton = $(".login-popup .popup-close-button");

    $toggler.on(this.pushEvent, function () {
        if ( $html.hasClass("login-popup-is-active" ) ) {
            $html.removeClass("login-popup-is-active");
        } else {
            $html.addClass("login-popup-is-active");
        }
    });

    $popupCloseButton.on(this.pushEvent, function () {
        if ( $html.hasClass("login-popup-is-active" ) ) {
            $html.removeClass("login-popup-is-active");
        } else {
            $html.addClass("login-popup-is-active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/login-popup.js